import { useMutation } from "@tanstack/react-query";
import { adminService } from "../services/admin.service";
import { BulkRoleRequest } from "../domain/types/admin.types";

export function useBulkManageRoles() {
  return useMutation({
    mutationFn: (req: BulkRoleRequest) => adminService.bulkManageRoles(req),
  });
}
